import React, {useEffect, useState} from "react";
import {Loader} from "../../utils/Loader";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import GoingBack from "../../components/GoingBack/GoingBack";
import "./AdminModern.scss";
import verifyRoleInJWTtoken from "../../services/VerifyRoleInJWTtoken";
import IsAdmin from "../../components/Admin/IsAdmin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";

function AdminOrders() {
    const [commandes, setCommandes] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [idClientClique, setIdClientClique] = useState(false);
    const [user, setUser] = useState([{}]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'descending' });

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        setIsLoading(false);
        const fetchAllOrders = async () => {
            setDataLoading(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}commandes/getAllOrders`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                });
                const commandes = await response.json();
                setCommandes(Object.values(commandes));
            } catch (error) {
                console.log(error);
            } finally {
                setDataLoading(false);
            }
        }
        fetchAllOrders();
    }, []);

    function fetchClientInformation(idClient) {
        try {
            const fetchClient = async () => {
                const response = await fetch(`${process.env.REACT_APP_API_URL}users/get-user-by-id/${idClient}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const client = await response.json();
                setUser(client);
                Swal.fire({
                    title: "Informations du client",
                    html: `<p><strong>Nom :</strong> ${client.nom}</p>
                               <p><strong>Prénom :</strong> ${client.prenom}</p>
                               <p><strong>Email :</strong> ${client.adresseEmail}</p>
                               <p><strong>Téléphone :</strong> ${client.numeroTel}</p>`,
                    icon: "info",
                });
            }
            fetchClient();
        } catch (error) {
            console.log(error);
        } finally {
            setIdClientClique(false);
        }
    }

    const handleClickDetails = (idCommande, contenuCommande) => {
        console.log("-------------------------------------------------")
        navigate("/profil/commandes/" + idCommande, {
            state: {
                contenuCommande: contenuCommande,
            },
        });
    };

    const myComposant = p => {
        return (
            <>
                <p style={{color: "blue", cursor: "pointer", margin: "0 0 1em 0"}}
                   onClick={() => handleClickDetails(p.data.idCommande, p.data.contenuCommande)}>Voir détails
                </p>
            </>
        );
    }

    function inverserFormatDate(date) {
        if (!date) return "";
        const [annee, mois, jour] = date.split('-');
        return `${jour}-${mois}-${annee}`;
    }

    const sortedCommandes = React.useMemo(() => {
        let sortableItems = [...commandes];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];
                if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return sortableItems;
    }, [commandes, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <FontAwesomeIcon icon={faSort} style={{ marginLeft: "0.5rem", opacity: 0.3 }} />;
        }
        if (sortConfig.direction === 'ascending') {
            return <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: "0.5rem" }} />;
        }
        return <FontAwesomeIcon icon={faSortDown} style={{ marginLeft: "0.5rem" }} />;
    };

    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            <GoingBack/>
            {!isAdmin ? null : (
                <>
                    <div className="admin-header">
                        <h2>Liste de toutes les commandes</h2>
                        <p>Consultez et gérez les commandes des clients</p>
                    </div>

                    <div className="admin-card">
                        {dataLoading ? (
                            <div style={{display: "flex", justifyContent: "center", padding: "3rem"}}>
                                <Loader />
                            </div>
                        ) : (
                            <div className="admin-data-list">
                                <div className="admin-data-header">
                                    <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('idCommande')}>
                                        Identifiant {getSortIcon('idCommande')}
                                    </div>
                                    <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('date')}>
                                        Date {getSortIcon('date')}
                                    </div>
                                    <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('prixTotal')}>
                                        Prix total {getSortIcon('prixTotal')}
                                    </div>
                                    <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('status')}>
                                        Statut {getSortIcon('status')}
                                    </div>
                                    <div style={{ flex: "0 0 120px", textAlign: "right" }}>Action</div>
                                </div>
                                
                                {sortedCommandes.map((commande, index) => {
                                    let badgeClass = "admin-badge-info";
                                    if (commande.status === "Annulé") badgeClass = "admin-badge-danger";
                                    else if (commande.status === "Livré") badgeClass = "admin-badge-success";
                                    else if (commande.status === "En cours de livraison") badgeClass = "admin-badge-warning";
                                    else if (commande.status === "Remboursé") badgeClass = "admin-badge-danger";
                                    
                                    return (
                                        <div key={index} className="admin-data-card">
                                            <div className="admin-data-row">
                                                <div className="admin-data-item">
                                                    <span className="admin-data-label">Identifiant</span>
                                                    <span className="admin-data-value" style={{ fontWeight: "bold" }}>{commande.idCommande}</span>
                                                </div>
                                                <div className="admin-data-item">
                                                    <span className="admin-data-label">Date</span>
                                                    <span className="admin-data-value">{inverserFormatDate(commande.date.substring(0, 10))}</span>
                                                </div>
                                                <div className="admin-data-item">
                                                    <span className="admin-data-label">Prix total</span>
                                                    <span className="admin-data-value">{commande.prixTotal} €</span>
                                                </div>
                                                <div className="admin-data-item">
                                                    <span className="admin-data-label">Statut</span>
                                                    <span className={`admin-badge ${badgeClass}`}>{commande.status}</span>
                                                </div>
                                            </div>
                                            <div className="admin-data-actions">
                                                <button className="admin-btn admin-btn-outline" style={{ padding: "0.5rem 1rem", fontSize: "0.85rem" }} onClick={() => handleClickDetails(commande.idCommande, commande.contenuCommande)}>
                                                    Voir détails
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                                {commandes.length === 0 && (
                                    <div style={{ textAlign: "center", padding: "2rem", color: "var(--admin-text-muted)" }}>
                                        Aucune commande trouvée.
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminOrders;